"use strict";
exports.__esModule = true;
var treewidget;
(function (treewidget) {
    /**
     * Define different type of functions to avoid confusion.
     */
    var ClipboardType;
    (function (ClipboardType) {
        ClipboardType[ClipboardType["CUT"] = 0] = "CUT";
        ClipboardType[ClipboardType["COPY"] = 1] = "COPY";
    })(ClipboardType = treewidget.ClipboardType || (treewidget.ClipboardType = {}));
    /**
     * This class handles clipboard functionality of tree widget. It
     * contains cut, copy and paste for any treenode. It should be able
     * to handle any type of input though, because no type is specified
     * in the methods. Paste only return an object but not handling
     * tree directly.
     */
    var Clipboard = /** @class */ (function () {
        function Clipboard() {
        }
        /**
         * Cut.
         * @param obj To be cut.
         */
        Clipboard.cut = function (obj) {
            Clipboard.cleanQueue();
            Clipboard.clipboardQueue.push(new ClipboardItem(ClipboardType.CUT, obj));
        };
        /**
         * Copy you know.
         * @param obj To be copy.
         */
        Clipboard.copy = function (obj) {
            Clipboard.cleanQueue();
            Clipboard.clipboardQueue.push(new ClipboardItem(ClipboardType.COPY, obj));
        };
        /**
         * Make a copy of the object then paste it.
         *
         * <b>Problem:</b> How to copy the functions of original
         *     object?
         * <b>Solution:</b> Call a constructor to build a new object.
         *
         * @return {ClipboardItem} Item to be paste. If clipboard is
         *     empty, return null.
         */
        Clipboard.paste = function () {
            var len = Clipboard.clipboardQueue.length;
            if (len > 0) {
                var itemToPaste = Clipboard.clipboardQueue[len - 1];
                // Make a copy of item to paste.
                // Notice that the copy can only copy properties. Must
                // call a constructor to build designate object.
                var copyItem = new ClipboardItem(itemToPaste.type, itemToPaste.item);
                if (itemToPaste.type === ClipboardType.CUT) {
                    // clean clipboard after cut and paste
                    Clipboard.cleanQueue();
                }
                return copyItem;
            }
            return null;
        };
        /**
         * Clean up clipboard by max number of queue. Seems a little
         * over engineered?
         */
        Clipboard.cleanQueue = function () {
            while (Clipboard.clipboardQueue.length >= Clipboard.queueMax) {
                Clipboard.clipboardQueue.shift();
            }
        };
        /**
         * A queue to handle clipboard. Modify queueMax to set the
         * maximum number of items the queue can hold.
         *
         * @type {Array}
         */
        Clipboard.clipboardQueue = [];
        /**
         * Max number of items that the queue can hold.
         *
         * @type {number}
         */
        Clipboard.queueMax = 1;
        return Clipboard;
    }());
    treewidget.Clipboard = Clipboard;
    /**
     * Any clipboard item will has a type and value. Type is to see it
     * is cut or copy, value is the exact item to handle.
     */
    var ClipboardItem = /** @class */ (function () {
        /**
         * Create a new clipboard item. Will not create any copy here
         * until an item is pasted, because a user may not paste after
         * cut/copy, or he may paste many times. So there are chances
         * that no copy is needed, or different copies are required.
         *
         * @param {ClipboardType} type Cut or copy. Call this value
         *     from ClipboardType to avoid confusion.
         * @param item The item to handle.
         */
        function ClipboardItem(type, item) {
            this.type = type;
            this.item = item;
        }
        return ClipboardItem;
    }());
    treewidget.ClipboardItem = ClipboardItem;
})(treewidget || (treewidget = {}));
exports["default"] = treewidget;
//# sourceMappingURL=tree-clipboard.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/tree/app/js/logic/tree-clipboard.js